import { Helmet } from 'react-helmet-async';
import '../App.css';
import { Header, Footer, WorkflowSection, FinalCta, useRevealObserver } from '../sections';

function HowItWorksPage(): JSX.Element {
  useRevealObserver();

  return (
    <div className="splash-root">
      <Helmet defer={false}>
        <title>How Loten Labs Localizes Your Game — Video Context</title>
        <meta name="description" content="Ship gameplay footage and strings. We align video context, lock your glossary, linguists review, we push to your repo in 30+ languages." />
        <link rel="canonical" href="https://useloten.com/how-it-works" />
        <meta property="og:title" content="How Loten Labs Localizes Your Game — Video Context" />
        <meta property="og:description" content="Ship gameplay footage and strings. We align video context, lock your glossary, linguists review, we push to your repo in 30+ languages." />
        <meta property="og:url" content="https://useloten.com/how-it-works" />
        <meta name="twitter:title" content="How Loten Labs Localizes Your Game — Video Context" />
        <meta name="twitter:description" content="Ship gameplay footage and strings. We align video context, lock your glossary, linguists review, we push to your repo in 30+ languages." />
      </Helmet>
      <a className="skip-link" href="#main-content">Skip to main content</a>

      <Header />

      <main id="main-content">
        <WorkflowSection
          heading={<>How Loten Labs turns gameplay into <span className="title-accent">perfect translations</span></>}
          subtitle="From strings in your repo to shippable translations in 30+ languages. Built for the producer who already knows where this process breaks."
        />
        <FinalCta />
      </main>

      <Footer />
    </div>
  );
}

export default HowItWorksPage;
